export function stripePayoutStatusStyle(){
    const defaultStyle = {
      'font-size': '14px',
    }

    return {
      paid: {
        ...defaultStyle,
        color: '#2acc73',
      },
  
      pending: {
        ...defaultStyle,
        color: '#ffcd07',
      },
  
      in_transit: {
        ...defaultStyle,
        color: '#788bda',
      },
  
      canceled: {
        ...defaultStyle,
        color: '#ee7266',
      },
  
      failed: {
        ...defaultStyle,
        color: '#ee7266',
      },
    }
  }
  
  export default  stripePayoutStatusStyle;